<h1 mat-dialog-title class="text-dark text-xl">{{ data.id ? 'Modifica Banca' : 'Nuova Banca' }}</h1>
<div mat-dialog-content class="w-full">
  <app-bank-account-form [data]="data"></app-bank-account-form>
</div>
